<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Plano de Conta Contábil</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroPlanoContaContabil" ref="formCadastroPlanoContaContabil" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.classificador" label="Classificador" :rules="fieldRules" :counter="20" maxlength="20" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.codigoReduzido" label="Código Reduzido" :rules="codigoReduzidoRules" :counter="20" maxlength="20" inputmode="numeric" @input="normalizarCodigoReduzido" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.tipo" label="Natureza" :items="tipoPlanoContaContabeis" item-value="key" item-text="value" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.tipoConta" label="Tipo da Conta" :items="tiposConta" item-value="key" item-text="value" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import PlanoContaContabilService from '../../../core/services/financeiro/PlanoContaContabilService';
import PlanoContaContabil from '../../../core/domain/financeiro/PlanoContaContabil';
import TipoPlanoContaContabilEnumService from '../../../core/services/financeiro/TipoPlanoContaContabilEnumService';
import TipoContaContabilEnumService from '../../../core/services/financeiro/TipoContaContabilEnumService';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroPlanoContaContabil' in this.$refs)
                this.$refs.formCadastroPlanoContaContabil.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new PlanoContaContabilService(),
        valid: true,
        dialog: false,
        isLoading: false,
        tipoPlanoContaContabeis: [],
        tiposConta: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        codigoReduzidoRules: [
            v => !v || /^\d+$/.test(v) || 'Informe somente números'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        normalizarCodigoReduzido(valor) {
            this.item.codigoReduzido = (valor || '').replace(/\D/g, '').slice(0, 20);
        },
        save() {

            if (this.$refs.formCadastroPlanoContaContabil.validate()) {

                this.salvando = true;

                let modelo = new PlanoContaContabil(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title || err.response.data, 'warning')
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }
        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        let tipoPlanoContaContabilEnumService = new TipoPlanoContaContabilEnumService();
        tipoPlanoContaContabilEnumService.Listar()
            .then(
                res => {
                    this.tipoPlanoContaContabeis = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let tipoContaContabilEnumService = new TipoContaContabilEnumService();
        tipoContaContabilEnumService.Listar()
            .then(
                res => {
                    this.tiposConta = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );
    }
}
</script>
